export default __webpack_public_path__ + "svg/calendar/2026/7/noviembre.svg?4acb710e";